import { makeAutoObservable } from 'mobx';

export class FiltersState {
    public isOpen: boolean = false;
    public activeSubmenu: string | null = null;

    public constructor() {
        makeAutoObservable(this);
    }

    public closeFilters = (): void => {
        this.isOpen = false;
    };

    public toggleFilters = (): void => {
        this.isOpen = !this.isOpen;
    };
}
